module.exports = __webpack_public_path__ + "img/jacobsen_Metaforens_mester1.c8913157.jpg";